(function () {
	'use strict';

	// Must stay in sync with UNTAGGED_CODE in projectListController.js: the folder
	// the component builds for untagged projects is drilled into by that controller.
	var UNTAGGED_CODE = '__dc_untagged__';
	var PREVIEW_SIZE = 9;

	ProjectTagFoldersController.$inject = ['API_BASE_URL_BACKEND'];
	function ProjectTagFoldersController(API_BASE_URL_BACKEND) {
		const vm = this;
		vm.folders = [];
		vm.untaggedCode = UNTAGGED_CODE;

		vm.$onChanges = onChanges;
		vm.pictogramUrl = pictogramUrl;
		vm.tileTitle = tileTitle;
		vm.open = open;
		vm.select = select;

		function onChanges(changes) {
			if (changes['projects'] || changes['selectedTags']) {
				vm.folders = selectFolders(buildFolders(vm.projects), vm.selectedTags);
			}
		}

		// A grouping tag selection picks folders, not projects: several selected
		// tags are a union of their folders. The untagged folder carries no code,
		// so it only shows when nothing is selected.
		function selectFolders(folders, selectedTags) {
			if (!selectedTags || !selectedTags.length) {
				return folders;
			}
			return _.filter(folders, function (folder) {
				return selectedTags.indexOf(folder.tag.code) > -1;
			});
		}

		function isUntagged(project) {
			return !project.grouping_tags || !project.grouping_tags[0];
		}

		// Every folder renders the same PREVIEW_SIZE grid so they share one
		// silhouette; slots past the project count are empty placeholders.
		function toSlots(preview) {
			const slots = [];
			for (let i = 0; i < PREVIEW_SIZE; i++) {
				slots.push({ project: preview[i] });
			}
			return slots;
		}

		// metadata.update_date is whatever the backend sends - epoch, ISO string or
		// a formatted one - so let moment parse it, the way $filter('date') does
		// elsewhere. Unparseable or absent sorts last.
		function updatedAt(project) {
			const value = project.metadata.update_date;
			if (!value) {
				return 0;
			}
			const time = moment(value).valueOf();
			return isNaN(time) ? 0 : time;
		}

		// Tiles are a preview of recent activity, so they keep their own order:
		// most recently updated first, whatever order the host handed in and
		// whichever projects it marked as favourites. The favourites-first rule and
		// the filter bar's criterion belong to the card lists, not to this preview.
		// _.sortBy is stable and ascending, hence the negated key.
		function byMostRecent(projects) {
			return _.sortBy(projects, function (project) {
				return -updatedAt(project);
			});
		}

		function toFolder(entry) {
			const projects = byMostRecent(entry.projects);
			const preview = projects.slice(0, PREVIEW_SIZE);
			return {
				tag: entry.tag,
				projects: projects,
				count: projects.length,
				preview: preview,
				slots: toSlots(preview),
				labelColor: tagLabelColor(entry.tag.color),
			};
		}

		// Folders are derived from the grouping tags carried by the projects: one
		// map entry per distinct grouping_tags[].code, plus the untagged default
		// entry. A project holding N grouping tags lands in N folders.
		function buildFolders(projects) {
			const allProjects = projects ? projects : [];
			const byCode = {};
			const untagged = [];

			_.each(allProjects, function (project) {
				if (isUntagged(project)) {
					untagged.push(project);
					return;
				}
				_.each(project.grouping_tags, function (tag) {
					if (!tag || !tag.code) {
						return;
					}
					if (!byCode[tag.code]) {
						// First occurrence wins for the colour.
						byCode[tag.code] = {
							tag: { code: tag.code, color: tag.color },
							projects: [],
						};
					}
					byCode[tag.code].projects.push(project);
				});
			});

			const folders = _.map(_.keys(byCode).sort(compareTagCodes), function (code) {
				return toFolder(byCode[code]);
			});

			if (untagged.length) {
				folders.push(toFolder({ tag: { code: UNTAGGED_CODE }, projects: untagged }));
			}

			return folders;
		}

		// The description is ellipsed in the tile, so the tooltip carries it whole.
		function tileTitle(project) {
			if (!project) {
				return '';
			}
			const label = project.metadata.label ? project.metadata.label : '';
			return project.metadata.description
				? label + '\n' + project.metadata.description
				: label;
		}

		function pictogramUrl(project) {
			const iconId = project.metadata.icon_id ? project.metadata.icon_id : -1;
			return API_BASE_URL_BACKEND + 'pictogramme_image?id=' + iconId;
		}

		function open(folder) {
			vm.onOpen({ tag: folder.tag });
		}

		// Navigation targets differ per project, so the host resolves them: the
		// component stays presentational and never touches $state.
		function select(project, event) {
			if (!project) {
				return;
			}
			// The folder itself opens on click - don't drill in as well.
			event.stopPropagation();
			vm.onSelect({ project: project });
		}
	}

	const projectTagFolders = {
		restrict: 'E',
		bindings: {
			projects: '<',
			selectedTags: '<',
			onOpen: '&',
			onSelect: '&',
		},
		controller: ProjectTagFoldersController,
		templateUrl:
			'./src/components/directives/project/project-tag-folders/project-tag-folders.component.html',
		controllerAs: 'vm',
	};

	angular.module('dcApp').component('projectTagFolders', projectTagFolders);
})();
